const advSelectors = [
  '.advContainer',
  '.video-article-page .advContainer',
  '.tabs-page .advContainer',
  '.home-page .advContainer',
  ':root .s-adv-shifting',
  '.c-adv',
  '.c-label--advertisement',
  '.s-adv-shifting-container'
];
const labelsSelectors = ['.c-label--article-heading', '.c-label--article-heading-light', '.c-label--article-heading-edited', '.c-label--article-heading-skyheadline', '.c-label--article-marker', '.c-label--article-sponsored', '.c-label--live', '.c-label--block-first', '.c-label-wrapper', '.c-hero__title+.c-label', '.c-hero__author-name-no-intro']
const componentsInViewportSelectors = ['.c-hero__label-wrapper']
const hiddenUtilitiesSelectors = ['.u-hidden-s', '.u-hidden-l', '.is-hidden']
const cardSelectors = ['.c-card__img-wrapper', '.c-card__content-data', '.c-card__info'];
const aspectRationSelectors = ['.o-aspect-ratio--16-9'];
const absolutePositionedSelectors = ['.o-absolute-positioned'];
const borderUtilsSelectors = ['.u-no-border'];
const flexUtilSelectors = ['.u-flex'];
const miscSelectors = [
  /\.is-active/g,
  /\.s-hero-sticky-player-wrapper/g,
];

// The selectors we put inside this array will be automatically
// included in all processes necessary to create a css file that
// will be lazy loaded on the client side when scrolling to this component
// with a 500px rootMargin
const LAZY_LOADED_CSS_SELECTORS = [/\.c-footer/];

// The selectors we put inside this array will be automatically
// excluded from all processes necessary to create the bundle of css
// we call it blacklist because these selectors are excluded from this bundle css build
// but force included in all CRITICAL CSS since those components are always visible on the screen
// and they are in all the pages
//
// IMPORTANT: forceInclude in Penthouse matches selectors by pattern, so we need to be comprehensive:
// - Use regex patterns that match the component class in any position
// - Include patterns for pseudo-classes (::before, ::after, :hover, etc.)
// - Include patterns for descendant and child selectors
const CLASSNAMES_BLACKLIST = [
  // Match .c-local-nav in any context (standalone, with descendants, with pseudo-classes, etc.)
  /\.c-local-nav/,
  // Match .c-global-nav in any context
  /\.c-global-nav/,
  // Match .c-login-bar in any context
  /\.c-login-bar/,
];

// The selectors we put inside this array will be automatically
// included in all the critical css files we extract for each theme
const CLASSNAMES_FORCE_INCLUDE = [
  ...miscSelectors,
  ...advSelectors,
  ...labelsSelectors,
  ...componentsInViewportSelectors,
  ...hiddenUtilitiesSelectors,
  ...cardSelectors,
  ...aspectRationSelectors,
  ...absolutePositionedSelectors,
  ...borderUtilsSelectors,
  ...flexUtilSelectors,
  ...CLASSNAMES_BLACKLIST,
];

/**
 * Array of CSS selectors to be force-included as standalone critical CSS files
 * These selectors are used to extract actual CSS rules from compiled CSS files for each theme.
 * The extracted rules are generated as separate HTML files during the critical CSS build process.
 * 
 * Output files: optimized-css/critical/{theme}/{theme}-standalone-force-include-critical.html
 * 
 * How it works:
 * 1. During build, the script reads the compiled CSS for each theme (production/{version}/css/style-{theme}.css)
 * 2. Uses PostCSS to parse the CSS and extract rules that match these selectors exactly
 * 3. Generates standalone HTML files with extracted rules wrapped in <style> tags
 * 4. Only includes selectors in themes specified in the 'themes' array (if empty or omitted, includes in all themes)
 * 
 * Use this when you need specific CSS rules to be:
 * - Available as standalone files that can be included separately from main critical CSS
 * - Extracted from actual compiled CSS (ensures all properties, media queries, and edge cases are included)
 * - Conditionally included only in specific themes
 * 
 * @type {Array<{ruleSelector: string, themes?: string[]}>}
 * @example
 * {
 *   ruleSelector: '.c-card__img-wrapper .icon--media',
 *   themes: ['tg24', 'sport'] // Only include in tg24 and sport, omit from entertainment
 * }
 */
const FORCE_INCLUDE_STANDALONE_SELECTORS = [
    {
      ruleSelector: '.c-card__img-wrapper .icon--media',
      themes: ['tg24', 'sport', 'entertainment']
    },
    {
      ruleSelector: '.c-card--CA10-d .c-card__img-wrapper .icon.icon--media',
      themes: ['tg24', 'sport', 'entertainment']
    },
    {
      ruleSelector: '.c-hero__media-wrapper .icon--media',
      themes: ['tg24', 'sport', 'entertainment']
    },
    {
      ruleSelector: '.c-banner-marketing',
      themes: ['tg24', 'sport', 'entertainment']
    },
    {
      ruleSelector: '.c-banner-marketing--slim',
      themes: ['tg24', 'sport', 'entertainment']
    },
    {
      ruleSelector: '.c-banner-marketing--slim .c-banner-marketing__img',
      themes: ['tg24', 'sport', 'entertainment']
    },
    {
      ruleSelector: '.c-hero__insights a',
      themes: ['tg24', 'sport', 'entertainment']
    }
  ]

/**
 * The key of the object will be used to filter the clientlibs css_lib_theme_name
 * In those css libs we will keep only the selectors that starts with the classnames
 * listed in the array value of each key
 * we will discard all the other css rules
 * along the way we will always keep all the rules that starts with l- (layout helpers)
 * and all the rules that descend from the classnames listed in the array value of each key
 * Configuration for filtering CSS clientlibs
 * Keys are patterns to match css_lib folder names
 * Values are arrays of component class prefixes to keep (along with their descending rules)
 * All selectors starting with 'l-' (layout helpers) are automatically kept
 * @type {Object.<string, string[]>}
 */
const CSS_CLIENTLIB_FILTERS = {
};

module.exports = {
  LAZY_LOADED_CSS_SELECTORS,
  CLASSNAMES_BLACKLIST,
  CLASSNAMES_FORCE_INCLUDE,
  CSS_CLIENTLIB_FILTERS,
  FORCE_INCLUDE_STANDALONE_SELECTORS
};
